import { Link } from "react-router-dom";

export const sleepApneaProducts = [
  {
    name: "BMC CPAP Machine RESmart GII",
    brand: "BMC",
    price: "₹19,990 – ₹23,299",
    originalPrice: "",
    discount: "42% Off",
    image:
      "https://tentabs.in/cdn/shop/files/WhatsApp_Image_2025-09-13_at_15.09.48_1.jpg?v=1769687762&width=900",
    description:
      "The BMC RESmart GII Auto CPAP is an intelligent auto-adjusting CPAP device designed for effective and comfortable treatment of Obstructive Sleep Apnea (OSA).",
  },
  {
    name: "BMC F2 Full Face Mask with Headgear",
    brand: "BMC",
    price: "₹1,280",
    originalPrice: "₹3,000",
    discount: "57% Off",
    image:
      "https://tentabs.in/cdn/shop/files/f22.webp?v=1769771851&width=900",
    description:
      "F2 Full Face mask is lightweight, easy to fit and designed for CPAP and BiPAP therapy.",
  },
  {
    name: "Philips Respironics Comfort Gel Nasal Mask",
    brand: "Philips Respironics",
    price: "₹3,400",
    originalPrice: "₹3,940",
    discount: "13% Off",
    image:
      "https://tentabs.in/cdn/shop/products/Philips_CG_Nasal.jpg?v=1580185883&width=900",
    description:
      "The Comfort Gel Nasal Mask adjusts easily to the contours of the nose to provide a leak-free seal.",
  },
  {
    name: "BMC BiPAP Machine RESmart GII Y30T",
    brand: "BMC",
    price: "₹26,400 – ₹30,000",
    originalPrice: "",
    discount: "45% Off",
    image:
      "https://tentabs.in/cdn/shop/files/WhatsApp_Image_2025-09-13_at_15.09.48.jpg?v=1757918254&width=900",
    description:
      "The BMC RESmart GII Y30T BiPAP Machine is an advanced non-invasive ventilator designed to offer respiratory support.",
  },
  {
    name: "Philips Respironics Comfort Gel Full Face Mask",
    brand: "Philips Respironics",
    price: "₹3,990",
    originalPrice: "₹7,500",
    discount: "46% Off",
    image:
      "https://tentabs.in/cdn/shop/files/comfortgel-blue-full-face-cpap-mask-1000x1000.jpg?v=1720686062&width=900",
    description:
      "A full-face mask designed for stability, comfort and effective CPAP therapy.",
  },
  {
    name: "BMC P2 Nasal Pillow Mask",
    brand: "BMC",
    price: "₹2,380",
    originalPrice: "₹4,500",
    discount: "47% Off",
    image:
      "https://tentabs.in/cdn/shop/products/51b8VnCKwhL._SL1000.jpg?v=1603968448&width=900",
    description:
      "A lightweight nasal pillow interface designed to be easy to assemble, wear and clean.",
  },
  {
    name: "BMC iVolve F1A Full Face Mask",
    brand: "BMC",
    price: "₹2,100 – ₹2,300",
    originalPrice: "",
    discount: "41% Off",
    image:
      "https://tentabs.in/cdn/shop/files/31c3fc79b7be42a448bae4b2247b0a6b528f0b54_original.jpg?v=1742540916&width=900",
    description:
      "A full-face mask with adjustable forehead frame designed for sleep, snoring and OSA therapy.",
  },
  {
    name: "BMC Headgear (Belt) Strap for CPAP Mask",
    brand: "BMC",
    price: "₹745",
    originalPrice: "₹2,000",
    discount: "62% Off",
    image:
      "https://tentabs.in/cdn/shop/files/Untitled_Project_57.jpg?v=1721123205&width=900",
    description:
      "Headgear designed to secure the CPAP mask and maintain effective therapy.",
  },
  {
    name: "BMC Hose Pipe for CPAP and BiPAP Machine",
    brand: "BMC",
    price: "₹999",
    originalPrice: "₹2,400",
    discount: "58% Off",
    image:
      "https://tentabs.in/cdn/shop/files/CPAP_BIPAP_Machine_Tube.jpg?v=1721124525&width=900",
    description:
      "A durable hose pipe compatible with BMC CPAP and BiPAP machines.",
  },
  {
    name: "BMC BIPAP Machine RESmart GII Y25T",
    brand: "BMC",
    price: "₹26,900 – ₹31,500",
    originalPrice: "",
    discount: "51% Off",
    image:
      "https://tentabs.in/cdn/shop/files/only_machine.jpg?v=1721124671&width=900",
    description:
      "A BiPAP machine suited for hospital respiratory care, sleep labs and step-down units.",
  },
  {
    name: "BMC Auto CPAP RESmart G2S A20 Luna",
    brand: "BMC",
    price: "₹21,000 – ₹21,299",
    originalPrice: "",
    discount: "27% Off",
    image:
      "https://tentabs.in/cdn/shop/files/41RaZBUVEzL._SL1000.jpg?v=1720261105&width=900",
    description:
      "An advanced auto-adjusting CPAP system designed for dependable sleep apnea therapy.",
  },
  {
    name: "BMC RESmart Humidifier for CPAP and BiPAP Machines",
    brand: "BMC",
    price: "₹7,490",
    originalPrice: "₹10,500",
    discount: "28% Off",
    image:
      "https://tentabs.in/cdn/shop/files/Untitled_Project_65.jpg?v=1721126492&width=900",
    description:
      "A heated humidification system designed to improve comfort during CPAP and BiPAP therapy.",
  },
  {
    name: "Oxygen Enrichment Adapter for CPAP and BiPAP Machines",
    brand: "BMC",
    price: "₹599",
    originalPrice: "₹1,000",
    discount: "40% Off",
    image:
      "https://tentabs.in/cdn/shop/files/WhatsApp_Image_2025-09-13_at_15.10.40.jpg?v=1758101615&width=900",
    description:
      "An adapter designed to connect oxygen supply with CPAP and BiPAP inputs.",
  },
  {
    name: "BMC N4 Nasal Mask",
    brand: "BMC",
    price: "₹1,400",
    originalPrice: "₹3,200",
    discount: "56% Off",
    image:
      "https://tentabs.in/cdn/shop/products/n4.jpg?v=1640934679&width=900",
    description:
      "A lightweight nasal interface designed for easy assembly, comfortable use and cleaning.",
  },
  {
    name: "BMC F4 Full Face Mask with Headgear",
    brand: "BMC",
    price: "₹1,350",
    originalPrice: "₹3,000",
    discount: "55% Off",
    image:
      "https://tentabs.in/cdn/shop/products/F4.jpg?v=1661761463&width=900",
    description:
      "A full-face CPAP interface designed for comfortable and reliable sleep apnea therapy.",
  },
  {
    name: "ResMed CPAP Airsense 10 Elite",
    brand: "ResMed",
    price: "29,900.00",
    originalPrice: "39,700.00",
    discount: "24% Off",
    image:
      "https://tentabs.in/cdn/shop/products/1_10_4e6fb0f2-309a-4956-90f1-af03180145b9.png?v=1618065812&width=900",
    description:
      "A CPAP device designed for sleep apnea therapy with advanced comfort and monitoring features.",
  },
  {
    name: "Philips Respironics Dreamstation Auto CPAP",
    brand: "Philips Respironics",
    price: "₹52,990 – ₹70,990",
    originalPrice: "",
    discount: "40% Off",
    image:
      "https://tentabs.in/cdn/shop/products/1_13_1d1a2510-3b4c-4eae-a732-61e0ad73c204.png?v=1596276124&width=900",
    description:
      "An Auto CPAP machine featuring SmartRamp and pressure adjustment features.",
  },
  {
    name: "VentMed Auto CPAP DS6 with Humidifier and Nasal Mask",
    brand: "VentMed",
    price: "₹21,900",
    originalPrice: "₹28,000",
    discount: "21% Off",
    image:
      "https://tentabs.in/cdn/shop/files/ventmedds6cpap.jpg?v=1769192243&width=900",
    description:
      "An Auto CPAP machine with integrated heated humidifier designed for obstructive sleep apnea management.",
  },
  {
    name: "BMC Auto CPAP G3 A20 Machine",
    brand: "BMC",
    price: "₹27,900 – ₹28,900",
    originalPrice: "",
    discount: "52% Off",
    image:
      "https://tentabs.in/cdn/shop/products/9_703be0e4-fe26-435a-9528-41041a3ad464.jpg?v=1661412985&width=900",
    description:
      "An Auto CPAP machine designed for obstructive sleep apnea with intelligent comfort settings.",
  },
  {
    name: "ResMed AirFit N30i Nasal Mask",
    brand: "ResMed",
    price: "5,846.00",
    originalPrice: "7,800.00",
    discount: "25% Off",
    image:
      "https://tentabs.in/cdn/shop/products/N30iNasalmask.jpg?v=1605334541&width=900",
    description:
      "A nasal cradle mask designed for comfortable sleep apnea therapy.",
  },
  {
    name: "DeVilbiss CPAP & BiPAP Filter",
    brand: "Devilbiss",
    price: "590.00",
    originalPrice: "1,000.00",
    discount: "41% Off",
    image:
      "https://tentabs.in/cdn/shop/products/1_b8af77fe-e023-4525-b7c8-2340c8281e25.jpg?v=1608189160&width=900",
    description:
      "Disposable ultra-fine filters and reusable foam are ready for use.",
  },
  {
    name: "Air Filter for Philips Remstar CPAP and BiPAP",
    brand: "Philips Respironics",
    price: "Rs.790.00",
    originalPrice: "Rs.1,000.00",
    discount: "21% Off",
    image:
      "https://tentabs.in/cdn/shop/products/3_302ddee4-0a1f-445f-8428-5846c9b59d64.jpg?v=1608189258&width=900",
    description: "Compatible with REMSTAR only.",
  },
  {
    name: "ResMed Mirage Quattro Full Face Mask",
    brand: "ResMed",
    price: "Rs.6,290-Rs.6,790.00",
    originalPrice: "",
    discount: "19% Off",
    image:
      "https://tentabs.in/cdn/shop/products/mirage.jpg?v=1560849253&width=900",
    description:
      "Flexible. Proven Mirage dual-wall cushion with Spring Air™ technology lets you move around while you're asleep.",
  },
  {
    name: "Philips Reusable Flexible tubing (Dia 15mm)",
    brand: "Philips Respironics",
    price: "Rs. 1,800.00",
    originalPrice: "2,800.00",
    discount: "35% Off",
    image:
      "https://tentabs.in/cdn/shop/products/1_25f7846f-6b5c-45af-b465-19c2652e2f1b.jpg?v=1662444651&width=900",
    description: "Fluid Typ-Compressed Air.",
  },
  {
    name: "Filters for Philips Dreamstation CPAP (Philips)",
    brand: "Philips Respironics",
    price: "Rs. 660.00",
    originalPrice: "1,000.00",
    discount: "34% Off",
    image:
      "https://tentabs.in/cdn/shop/files/philips-respironics-dreamStation-cpap-filter-2-pack.jpg?v=1721638944&width=900",
    description:
      "Brand-Philips, Filtration Grade-Ultra Fine, Color-White, Shape-Rectangle, Frame Material-Plastic",
  },
  {
    name: "Philips Respironics Dreamstation Humidifier",
    brand: "Philips Respironics",
    price: "Rs. 15,900.00-Rs. 17,990.00",
    originalPrice: "",
    image:
      "https://tentabs.in/cdn/shop/products/dreamstation-heated-humidifier-top-view.jpg?v=1595912231&width=900",
    description:
      "Philips Respironics has not only rejuvenated its humidification system with the DreamStation, but reinvention is also evident.",
  },
  {
    name: "ResMed Nasal Pillow Mask AirFit P10",
    brand: "ResMed",
    price: "Rs.4,980.00",
    originalPrice: "6,600.00",
    discount: "24% Off",
    image:
      "https://tentabs.in/cdn/shop/files/P10_nasal_pillow_mask-2.png?v=1720076746&width=900",
    description:
      "The AirFit P10's three-piece simple design simplifies installation, fitting, and cleaning.",
  },
  {
    name: "BMC iVolve N2 Nasal Mask",
    brand: "BMC",
    price: "Rs.1,299.00",
    originalPrice: "3,200.00",
    discount: "59% Off",
    image:
      "https://tentabs.in/cdn/shop/files/iVolve-N2-Nasal-Mask-01-scaled.jpg?v=1721123624&width=900",
    description:
      "Adjustable forehead elastic support - Gives you a wider range of comfort",
  },
  {
    name: "BMC N6 Nasal Pillow Mask",
    brand: "BMC",
    price: "Rs.2,880.00",
    originalPrice: "Rs.2,880.00",
    discount: "42% Off",
    image:
      "https://tentabs.in/cdn/shop/files/N6CPAP3.jpg?v=1769188304&width=900",
    description:
      "The mask has adjustable headgear which fits for most of the head sizes.",
  },
  {
    name: "ResMed Bestfit 2 Nasal Vented Mask",
    brand: "ResMed",
    price: "Rs.2,290.00",
    originalPrice: "3,500.00",
    discount: "34% Off",
    image:
      "https://tentabs.in/cdn/shop/products/bestfit.jpg?v=1572606725&width=900",
    description:
      "Advanced Cushion Design allows active control of the seal. The specialized vent ports disperse airflow efficiently and quietly.",
  },
  {
    name: "BMC F6 Full Face Mask",
    brand: "BMC",
    price: "Rs.3,800.00-Rs.3,990.00",
    originalPrice: "",
    discount: "36% Off",
    image:
      "https://tentabs.in/cdn/shop/products/6_7e55d423-5b10-4f4b-a4ca-32e3cacaf187.jpg?v=1652776760&width=900",
    description:
      "The Innovative BMC F6 under the nose cushion brings liberty for the nasal bridge and meanwhile minimizes the claustrophobia.",
  },
  {
    name: "ResMed Hose Pipe For CPAP and BiPAP",
    brand: "ResMed",
    price: "Rs.2,950.00",
    originalPrice: "3,200.00",
    discount: "7% Off",
    image:
      "https://tentabs.in/cdn/shop/products/51L98zDO4QL._SL1000.jpg?v=1605690134&width=900",
    description:
      "Size-DIA 22 mm, Type-Spiral, Fluid Type-Compressed Air",
  },
  {
    name: "ResMed AirTouch F20 Full Face Mask",
    brand: "ResMed",
    price: "Rs.6,350.00",
    originalPrice: "8,100.00",
    discount: "21% Off",
    image:
      "https://tentabs.in/cdn/shop/products/airtouch-f201.jpg?v=1615446083&width=900",
    description:
      "Softest mask ever, the AirTouch F20 is the very first to feature the revolutionary ResMed UltraSoft memory foam cushion.",
  },
  {
    name: "ResMed Airfit F20 Headgear",
    brand: "ResMed",
    price: "Rs.2,490.00",
    originalPrice: "4,700.00",
    discount: "47% Off",
    image:
      "https://tentabs.in/cdn/shop/products/4_06ce95a0-ea87-415c-ac03-3aef187522c2.jpg?v=1637664861&width=900",
    description:
      "ResMed AirFit F20 Headgear is a direct replacement headgear for the AirFit F20 Full Face CPAP Masks.",
  },
  {
    name: "Humidifier for Philips Respironics System one",
    brand: "Philips Respironics",
    price: "Rs.14,200.00-Rs.15,000.00",
    originalPrice: "",
    discount: "21% Off",
    image:
      "https://tentabs.in/cdn/shop/files/Screenshot_c635d609-0b46-4df3-9bfb-ba4ec3b6be43.png?v=1753183205&width=900",
    description:
      "This heated humidifier is designed to bring more comfort and better performance to all CPAP.",
  },
  {
    name: "BMC BIPAP G2S B25vT with Humidifier",
    brand: "BMC",
    price: "Rs.22,499.00",
    originalPrice: "50,000.00",
    discount: "55% Off",
    image:
      "https://tentabs.in/cdn/shop/files/G2S_B30VT_Nasal_Mask_9058461a-8c29-46ae-81d9-9ea8c86cc9d2.jpg?v=1769765726&width=900",
    description:
      "Quiet and patient-friendly. Operates under 30 dB, suitable for sleep labs and shared wards.",
  },
  {
    name: "Philips Hose Pipe for Dreamstation (Dia 15mm)",
    brand: "Philips Respironics",
    price: "Rs.1,300.00",
    originalPrice: "Rs.2,500.00",
    discount: "48% Off",
    image:
      "https://tentabs.in/cdn/shop/products/1111_e28bb6e3-b469-4706-a029-c05067e500d6.jpg?v=1626252159&width=900",
    description:
      "Size-DIA 15 mm, Type-Spiral, Fluid Type-Compressed Air, Unit Length-1m-6m, Used for-Dreamstation CPAP/BIPAP",
  },
  {
    name: "BMC F5A Full Face Mask",
    brand: "BMC",
    price: "Rs.2,699.00-Rs.2,750.00",
    originalPrice: "",
    discount: "32% Off",
    image:
      "https://tentabs.in/cdn/shop/products/BMCF5AFFM.webp?v=1653117383&width=900",
    description:
      "BMC F5A Full Face CPAP Mask - Freedom from Forehead Frame",
  },
  {
    name: "Philips Respironics Dreamwear Gel Pillow Nasal",
    brand: "Philips Respironics",
    price: "Rs.5,299.00",
    originalPrice: "Rs.9,900.00",
    discount: "46% Off",
    image:
      "https://tentabs.in/cdn/shop/products/dreamwearnasalpillowmask.jpg?v=1599126840&width=900",
    description:
      "With the introduction of the gel pillows, the Philips Respironics DreamWear adds another dimension to comfort within the same mask.",
  },
  {
    name: "Adapter for BMC CPAP and BiPAP (ORIGINAL)",
    brand: "BMC",
    price: "Rs.8,500.00",
    originalPrice: "Rs.10,000.00",
    discount: "15% Off",
    image:
      "https://tentabs.in/cdn/shop/products/idunmed-DC-24V-Power-Adapter-For-BMC-CPAP-APAP-BPAP-Machine-Accessories.jpg_350x350__01.jpg?v=1606225485&width=900",
    description:
      "Compatible with all BMC CPAP and BiPAP models",
  },
  {
    name: "Philips True Blue Nasal Mask",
    brand: "Philips Respironics",
    price: "Rs.5,500.00",
    originalPrice: "8,400.00",
    discount: "34% Off",
    image:
      "https://tentabs.in/cdn/shop/products/tttttt.jpg?v=1753355941&width=900",
    description:
      "The Philips Respironics TrueBlue CPAP BIPAP Mask features premium blue gel which forms an effective seal.",
  },
  {
    name: "Philips Respironics Amara View Minimal Contact",
    brand: "Philips Respironics",
    price: "Rs.8,200.00",
    originalPrice: "Rs.11,010.00",
    discount: "25% Off",
    image:
      "https://tentabs.in/cdn/shop/files/Screenshot_1832ac05-a267-467f-a1dd-746311fe52ae.png?v=1753248654&width=900",
    description: "Amara silicone for an exceptionally light mask.",
  },
  {
    name: "Philips Respironics Pico Nasal Mask with",
    brand: "Philips Respironics",
    price: "Rs.2,800.00-Rs.2,990.00",
    originalPrice: "",
    discount: "33% Off",
    image:
      "https://tentabs.in/cdn/shop/products/pico_2.jpg?v=1572606119&width=900",
    description: "Comfortably fits more than 98% of users.",
  },
  {
    name: "Air Filter for BMC CPAP and BiPAP (Pack of 2)",
    brand: "BMC",
    price: "Rs.780.00",
    originalPrice: "Rs.1,000.00",
    discount: "22% Off",
    image:
      "https://tentabs.in/cdn/shop/files/4.jpg?v=1722509658&width=900",
    description: "Compatible with all models of BMC CPAP and BiPAP",
  },
  {
    name: "Filter for ResMed CPAP/BiPAP",
    brand: "ResMed",
    price: "Rs.400.00",
    originalPrice: "",
    image:
      "https://tentabs.in/cdn/shop/products/321.jpg?v=1626161092&width=900",
    description:
      "These disposable air filters are designed for use with ResMed devices.",
  },
  {
    name: "BMC F4 Full Face Mask with Headgear",
    brand: "BMC",
    price: "Rs.1,350.00",
    originalPrice: "Rs.3,000.00",
    discount: "55% Off",
    image:
      "https://tentabs.in/cdn/shop/products/F4.jpg?v=1661761463&width=900",
    description: "Properties: Patients' CPAP interface.",
  },
  {
    name: "BMC N4 Nasal Mask",
    brand: "BMC",
    price: "Rs.1,400.00",
    originalPrice: "Rs.3,200.00",
    discount: "56% Off",
    image:
      "https://tentabs.in/cdn/shop/products/n4.jpg?v=1640934679&width=900",
    description: "The N4 by BMC is a new lightweight Nasal Interface.",
  },
  {
    name: "Oxygen Enrichment Adapter for CPAP and BiPAP",
    brand: "BMC",
    price: "Rs.599.00",
    originalPrice: "1,000.00",
    discount: "40% Off",
    image:
      "https://tentabs.in/cdn/shop/files/WhatsApp_Image_2025-09-13_at_15.10.40.jpg?v=1758101615&width=900",
    description:
      "Suitable adaptor for connecting the Oxygen supply and the CPAP/BiPAP inputs together.",
  },
  {
    name: "BMC RESmart Humidifier for CPAP and BiPAP",
    brand: "BMC",
    price: "Rs.7,490.00",
    originalPrice: "Rs.10,500.00",
    discount: "28% Off",
    image:
      "https://tentabs.in/cdn/shop/files/Untitled_Project_65.jpg?v=1721126492&width=900",
    description:
      "The RESmart Heated Humidifier for the RESmart CPAP/BiPAP Machine is a high tech humidification system that will add comfort and help prevent dryness.",
  },
];

const SleepApnea = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">
        Sleep Apnea
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {sleepApneaProducts.map((product, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="w-full h-60 flex items-center justify-center bg-white p-4">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-contain"
              />
            </div>

            <div className="p-4">
              <p className="text-sm text-gray-500 mb-1">
                {product.brand}
              </p>

              <h2 className="text-base font-semibold text-gray-900 min-h-[48px]">
                {product.name}
              </h2>

              <p className="text-sm text-gray-600 mt-2 line-clamp-3">
                {product.description}
              </p>

              <div className="flex items-center gap-2 mt-4">
                <span className="text-lg font-bold text-gray-900">
                  {product.price}
                </span>

                {product.originalPrice && (
                  <span className="text-sm text-gray-400 line-through">
                    {product.originalPrice}
                  </span>
                )}
              </div>

              {product.discount && (
                <span className="inline-block mt-2 text-sm font-medium text-green-600">
                  {product.discount}
                </span>
              )}

              <Link
                to={`/medical-devices/sleep-apnea/${index}`}
                className="block w-full mt-4 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition text-center"
              >
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SleepApnea;